export default __webpack_public_path__ + "static/media/i_bus-tro_rd.003ed108.svg";